import React, { useEffect, useId, useState } from "react";
import { Breadcrumb, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import userService from "../../app/services/user.service";
import BtnWrapper from "../../UI/BtnWrapper";
import Card from "../../UI/Card/Card";
import ConfirmationModal from "../../UI/ConfirmationModal/ConfirmationModal";
import Graybg from "../../UI/Graybg";
import SecBTN from "../../UI/SecBTN";
import SuccessModal from "../../UI/SuccessModal/SuccessModal";
import classes from "./PaperFormat.module.css";
import moment from "moment";
import Loader from "../../UI/loader/loader";
import { toast } from "react-toastify";
import Toast from "../../UI/Toast/Toast";


const Activate = ({
  target,
  format,
  total_question,
  name,
  date,
  onEdit,
  onDeactivateHandler,
  formatid
}) => {
const time = moment(date).utc().format('YYYY-MM-DD h:mm:ss')
const id = useId()
  return (
    <>
      <Card>
        <Row>
          <Col lg={9} md={12} sm={12}>
            <h5>{format}</h5>
            <div className={classes.flex}>
              <p>
                Target : <b>{target}</b>
              </p>
              <p>
                Total Questions : <b>{total_question}</b>
              </p>
            </div>
            <div className={classes.flex}>
              <p>
                Paper Requested By : <b>{name}</b>
              </p>
              <p>
                Paper Requested On :{" "}
                {/* <b>{`${year}-${month}-${day} `}</b> */}
                <b>{time}</b>
              </p>
            </div>
            <Row>
              <Col lg={5} md={12}></Col>
              <Col lg={7} md={12}></Col>
            </Row>
          </Col>
          <Col lg={3} md={12} sm={12}>
            <div className="d-flex justify-content-lg-end justify-content-md-center justify-content-sm-center">
              <Link to={`/paperFormat/edit/${formatid}`}>
                <SecBTN className={classes.edit} onClick={onEdit}>
                  Edit
                </SecBTN>
              </Link>
              <SecBTN id={id+formatid} className={classes.activate} onClick={() => onDeactivateHandler(formatid,id+formatid)}>
              De-Activate
              </SecBTN>
            </div>
          </Col>
        </Row>
      </Card>
    </>
  );
};

const Deactivate = ({ target,format,total_question,name,onEdit,date, onActivateHandler,formatid }) => {
  const time = moment(date).utc().format('YYYY-MM-DD h:mm:ss')
  const id = useId()
  return (
    <>
      <Card>
        <Row>
        <Col lg={9} md={12} sm={12}>
              <h5>{format}</h5>
            <div className={classes.flex}>
              <p>
                Target : <b>{target}</b>
              </p>
              <p>
                Total Questions : <b>{total_question}</b>
              </p>
            </div>
            <div className={classes.flex}>
              <p>
                Paper Requested By : <b>{name}</b>
              </p>
              <p>
                Paper Requested On :{" "}
                {/* <b>{`${year}-${month}-${day} `}</b> */}
                <b>{time}</b>
              </p>
            </div>
            <Row>
              <Col lg={5} md={12}></Col>
              <Col lg={7} md={12}></Col>
            </Row>
          </Col>
          <Col lg={3} md={12} sm={12}>
            <div className="d-flex justify-content-lg-end justify-content-md-center justify-content-sm-center">
              <Link to={`/paperFormat/edit/${formatid}`}><SecBTN className={classes.edit} onClick={onEdit}>
                Edit
              </SecBTN>
              </Link>
              <SecBTN id={id+formatid} className={classes.activate} onClick={() => onActivateHandler(formatid,id+formatid)}>
                Activate
              </SecBTN>
            </div>
          </Col>
        </Row>
      </Card>
    </>
  );
};

const PaperFormat = () => {
  // const uid = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;
  const x = JSON.parse(localStorage.getItem('user'))?.data?.user
  const [isPending, setISPending] = useState(true);
  const clickHandler = () => {
    setISPending((click) => !click);
  };
  const [loading, setLoading] = useState(false);
  const [showPopUp1, setShowPopUp1] = useState(false);
  const [showPopUp2, setShowPopUp2] = useState(false);
  const [activeData, setActiveData] = useState([]);
  const [deactiveData, setDeactiveData] = useState([]);
  const fetchInitialData = async() => {
    setLoading(true)
  
    let body = {
      profile_id: x?.profile_id,
      user_id: x?.user_id,
    };
      await userService.getFormatList(body)
      .then(res => {
        const active = res.data.filter(x => x.active===1) 
        const deactive = res.data.filter(x => x.active===0) 
        console.log("active",active);
        setActiveData(active)
        setDeactiveData(deactive)
        setLoading(false);
        
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          toast.error(error.response.data.message);
        } else if (error.request) {
          toast.error("network error");
        } else {
          console.log(error);
          toast.error(error);
        }
      });
  }
useEffect(() => {
  fetchInitialData();
  }, []);
  
  const onActivateHandler = (formatid, id) => {
    // setShowPopUp1(true);
    const body = {
      format_id: formatid,
      status: "1",
      created_by: x?.user_id,
    };
    setLoading(true)
    userService.formatStatus(body)
    .then(res => {
      console.log(res);
      toast.success("Format activated successfully!!");
      setLoading(false)
      fetchInitialData() 
      // .then(() => {
      //   setISPending(!isPending)
      //   document.getElementById(id).scrollTop = 50
      // })
    })
    .catch(error => {
      console.log(error);
      setLoading(false)
      toast.error("Something went wrong!!");
    })
  };
  const onDeactivateHandler = (formatid, id) => {
    // setShowPopUp1(true);
    const body = {
      format_id: formatid,
      status: "0",
      created_by: x?.user_id,
    };
    setLoading(true)
    userService.formatStatus(body)
    .then(res => {
      console.log(res);
      toast.success("Format activated successfully!!");
      setLoading(false)
      fetchInitialData()
      // .then(() => {
      //   setISPending(!isPending)
      //   document.getElementById(id).scrollTop = 50
      // })
    })
    .catch(error => {
      console.log(error);
      setLoading(false)
      toast.error("Something went wrong!!");
    })
  };
  const yesHandler = () => {
    setShowPopUp1(false);
    setShowPopUp2(true);
  };
  const onHideHandler = () => {
    setShowPopUp1(false);
    setShowPopUp2(false);
  };
  return (
    <>
    <Toast/>
    <div className="section">
      {loading && <Loader />}
      <ConfirmationModal
        title={`Are you sure you want to ${
          isPending ? "DE-ACTIVATE" : "ACTIVATE"
        } this format?`}
        show={showPopUp1}
        onHide={onHideHandler}
        yesHandler={yesHandler}
        confirmTxt="yes"
      />
      <SuccessModal
        show={showPopUp2}
        onHide={onHideHandler}
        title={`Format ${
          isPending ? "Activated" : "De-Activated"
        } Successfully!`}
        btnTxt="Ok"
      />
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <h4>Paper Format</h4>
          <Breadcrumb>
            <Breadcrumb.Item active>Paper Format</Breadcrumb.Item>
            <Breadcrumb.Item active>
              {isPending ? "Active" : "Deactive"}
            </Breadcrumb.Item>
            {/* <Breadcrumb.Item active>Completed</Breadcrumb.Item>
            <Breadcrumb.Item active>Questions</Breadcrumb.Item> */}
          </Breadcrumb>
        </div>
        <Link to="/paperFormat/edit/0">
          <SecBTN className={classes["sec-btn1"]}>Add New Format</SecBTN>
        </Link>
      </div>
      <Graybg>
        <BtnWrapper>
          <SecBTN
            className={isPending ? "active" : ""}
            onClick={clickHandler}
            type="button"
          >
            Active
          </SecBTN>
          <SecBTN
            className={isPending ? "" : "active"}
            onClick={clickHandler}
            type="button"
          >
            Deactive
          </SecBTN>
        </BtnWrapper>
        {isPending ? (
          <>
            {activeData.map((data) => {
              return (
                <Activate
                format={data.paper_format}
                  target={data.TblTarget.target}
                  total_question={data.total_questions}
                  name={data.TblUserInfo.name}
                  date={data.created_on}
                  onDeactivateHandler={onDeactivateHandler}
                  formatid={data.format_id}
                />
              );
            })}
          </>
        ) : (
          <>
            {deactiveData.map((data) => {
              return (
                <Deactivate
                  format={data.paper_format}
                  target={data.TblTarget.target}
                  total_question={data.total_questions}
                  name={data.TblUserInfo.name}
                  date={data.created_on}
                  onActivateHandler={onActivateHandler}
                  formatid={data.format_id}
                />
              );
            })}
          </>
        )}
      </Graybg>
    </div>
    </>
  );
};

export default PaperFormat;
